import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {VehicleState, DamageCase, DamageDocument, Damage, DamageArea, DamageType, DamageImage} from '../../../../models/models';
import {Translation} from '../../../../models/translation';
import {DamageAdministrationService} from '../../../../services/damage-administration.service';
import {LoginService} from '../../../../services/login.service';
import {VehicleStateService} from '../../../../services/vehiclestates.service';
import {CheckService} from '../../../../services/check.service';
import {UntypedFormControl} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ColumnModel, GridComponent} from '@syncfusion/ej2-angular-grids';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import Swal from 'sweetalert2';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

const moment = _moment;
export const CustomFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'DD.MM.YYYY',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};

@Component({
  selector: 'app-damage-case-record',
  templateUrl: './damage-case-record.component.html',
  styleUrls: ['./damage-case-record.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
      provide: MAT_DATE_FORMATS, useValue: CustomFormats
    },
    [DatePipe]
  ],
})
export class DamageCaseRecord implements OnInit {

  // @ts-ignore
  @ViewChild('senderDateInput') senderDateInput: ElementRef;
  @ViewChild('damageCaseGrid', {static: true}) private damageCaseGrid: GridComponent;

  public translation: Translation;
  public language: string;
  public locale: string;
  public selectedIndex = 0;
  public differentVehicle: boolean = false;
  public damageCaseOptions: ColumnModel[];
  public damageCaseDataSource: VehicleState[] = [];
  public deliveryState = '';
  public damageComment = '';
  public damageDocuments: DamageDocument[];
  public damageTypes: DamageType[] = [];
  public damageAreas: DamageArea[] = [];
  
  public date = new UntypedFormControl(moment());
  public tempDate: Date = new Date();
  public maxDate: Date = new Date();
  public minDate: Date = new Date(this.tempDate.getFullYear(), this.tempDate.getMonth(), this.tempDate.getDate() - 1, this.tempDate.getHours(), this.tempDate.getMinutes(), this.tempDate.getSeconds(), this.tempDate.getMilliseconds());
  public timeSelects: string[] = [];

  public damageCase = new DamageCase();
  public damage = new Damage();
  public toolbar = [];

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private damageAdministrationService: DamageAdministrationService,
    private vehicleStateService: VehicleStateService,
    private datepipe: DatePipe) {}
  
  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(5);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.language = localStorage.getItem('Language');
    this.loadTimePicker();
    this.getDamageAreas();
    this.getDamageTypes();
    this.initData();
    this.loadDataForGrid();
  }
  
  public loadTimePicker() {
    const quarterHours = ['00', '15', '30', '45'];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 4; j++) {
        let time = '';
        if (i < 10) {
          time = '0' + i + ':' + quarterHours[j];
        } else {
          time = i + ':' + quarterHours[j];
        }
        this.timeSelects.push(time);
      }
      this.damageCase.DamageTime = this.timeSelects[0];
    }
  }
  
  public loadDataForGrid() {
    this.vehicleStateService.getVehicleStatesForDamageReportGrid(+sessionStorage.getItem('UserId')).subscribe(response => {
      if (response.Ok) {
        this.damageCaseDataSource = response.Obj;
        this.initGrid();
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }), error => { this.toast.fire(this.translation.InternalServerError, '', 'error')};
  }

  public getDamageAreas() {
    this.damageAdministrationService.getDamageAreas().subscribe(response => {
      if (response.Ok) {
        this.damageAreas = response.Obj;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }), error => { this.toast.fire(this.translation.InternalServerError, '', 'error')};
  }
  
  public getDamageTypes() {
    this.damageAdministrationService.getDamageTypes().subscribe(response => {
      if (response.Ok) {
        this.damageTypes = response.Obj;
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }), error => { this.toast.fire(this.translation.InternalServerError, '', 'error')};
  }

  public getDamageAreaDescription(id: number): string {
    const area = this.damageAreas.find(a => a.Id === id);
    if (!area) return '';
    return this.getDescriptionByLanguage(area);
  }
  
  public getDamageTypeDescription(id: number): string {
    const type = this.damageTypes.find(t => t.Id === id);
    if (!type) return '';
    return this.getDescriptionByLanguage(type);
  }

  private getDescriptionByLanguage(item: { Code: number; DescriptionDE: string; DescriptionIT: string; DescriptionEN: string; DescriptionFR: string }): string {
    switch (this.language) {
      case 'DE': return item.Code + ' - ' + item.DescriptionDE;
      case 'IT': return item.Code + ' - ' + item.DescriptionIT;
      case 'EN': return item.Code + ' - ' + item.DescriptionEN;
      case 'FR': return item.Code + ' - ' + item.DescriptionFR;
      default: return item.Code + ' - ' + item.DescriptionDE;
    }
  }
  
  public initGrid() {
    this.damageCaseGrid.allowExcelExport = true;
    this.damageCaseGrid.allowPaging = true;
    this.damageCaseGrid.pageSettings = {pageCount: 5, pageSize: 14};
    //this.damageCaseGrid.toolbar = [{ text: this.translation.DifferentVehicle, cssClass: 'red-toolbar-btn', id: 'AddDifferentVehicle' }, 'Search'];
    this.damageCaseGrid.toolbar = ['Search'];
    this.damageCaseGrid.allowResizing = true;
    this.damageCaseGrid.editSettings = {allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal'};
    this.damageCaseOptions = [
      {
        field: 'OrderId',
        headerText: this.translation.OrderNumber,
        textAlign: 'Left',
        isPrimaryKey: true,
        autoFit: true
      },
      {
        field: 'Sender',
        headerText: this.translation.Sender,
        textAlign: 'Left',
        autoFit: true,
        valueAccessor: (field: string, data: any, column: any) => {
          return `${data.SenderName}, ${data.SenderCity}`;
        },
      },
      {
        field: 'Recipient',
        headerText: this.translation.Recipient,
        textAlign: 'Left',
        autoFit: true,
        valueAccessor: (field: string, data: any, column: any) => {
          return `${data.RecipientName}, ${data.RecipientCity}`;
        },
      },
      {
        field: 'ModelName',
        headerText: this.translation.Model,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'ClientReference1',
        headerText: this.translation.ChassisNumber,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'ClientReference2',
        headerText: this.translation.Reference,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'ClientReference3',
        headerText: this.translation.Mark,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'DeliveryStatus',
        headerText: this.translation.Status,
        textAlign: 'Left',
        autoFit: true
      },
      {
        field: 'DeliveryAppointment',
        headerText: this.translation.DeliveryDate,
        textAlign: 'Left',
        autoFit: true
      }
    ];
  }
  
  public initData() {
    this.damageCase.Id = 0;
    this.damageCase.DamageDate = new Date().toLocaleDateString();
    this.damageCase.OriginalSender = '';
    this.damageCase.OriginalRecipient = '';
    this.damageCase.OriginalModel = '';
    this.damageCase.CaseEnd = '';
    this.damageCase.Reimbursement = '';
    this.damageCase.DamageTime = '12:00';
    this.damageCase.InsuranceId = null;
    this.damageCase.JobTypeId = null;
    this.damageCase.JobTypeDisplayName = '';
    this.damageCase.CausedById = null;
    this.damageCase.CausedByDisplayName = '';
    this.damageCase.SenderId = null;
    this.damageCase.SenderDisplayName = '';
    this.damageCase.WorkshopId = null;
    this.damageCase.WorkshopDisplayName = '';
    this.damageCase.BrandId = null;
    this.damageCase.BrandDisplayName = '';
    this.damageCase.CarTypeId = null;
    this.damageCase.CarTypeDisplayName = '';
    this.damageCase.ImporterId = null;
    this.damageCase.ImporterDisplayName = '';
    this.damageCase.ReceiverId = null;
    this.damageCase.ReceiverDisplayName = '';
    this.damageCase.PolicyNo = null;
    this.damageCase.Identification = '';
    this.damageCase.License = '';
    this.damageCase.ChassisNo = '';
    this.damageCase.CostEstimate = null;
    this.damageCase.DamageAmount = null;
    this.damageCase.InsuranceAmount = null;
    this.damageCase.OwnCosts = null;
    this.damageCase.Comment = '';
    this.damageCase.InsuranceComment = '';
    this.damageCase.Guilty = false;
    this.damageCase.PrimaryAddressId = 0;
    this.damageCase.TransitId = null;
    this.damageCase.ReportedByCustomer = false;
    this.damageCase.UserId = +sessionStorage.getItem('UserId');
    this.damageCase.CreatedBy = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.damageCase.LastChangeBy = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.damageCase.DamageDocuments = [];
    this.damageCase.Damages = [];
    this.damageCase.Feeds = [];

    this.deliveryState = '';
    this.damage.InEdit = false;
    this.damage.Images = [];
  }
  
  openDatePicker(picker: MatDatepicker<Date>) {
    picker.open();
    setTimeout(() => this.senderDateInput.nativeElement.focus());
  }
  
  goBack(): void {
    this.differentVehicle = false;
    this.selectedIndex = 0;
  }
  
  damageCaseRowSelect(args: any) {
    this.initData();
    this.damageCase.TransitId = args.data.OrderId;
    this.damageCase.SenderDisplayName = args.data.SenderName + ', ' + args.data.SenderCity;
    this.damageCase.ReceiverDisplayName = args.data.RecipientName + ', ' + args.data.RecipientCity;
    this.damageCase.CarTypeDisplayName = args.data.ModelName;
    this.damageCase.Identification = args.data.ClientReference2;
    this.damageCase.ChassisNo = args.data.ClientReference1;
    this.damageCase.License = args.data.ClientReference3;
    this.damageCase.OriginalSender = args.data.SenderName + ', ' + args.data.SenderCity;
    this.damageCase.OriginalRecipient = args.data.RecipientName + ', ' + args.data.RecipientCity;
    this.damageCase.OriginalModel = args.data.ModelName;
    this.deliveryState = args.data.DeliveryStatus + ' - ' + args.data.DeliveryAppointment;
    this.selectedIndex = 1;
  }

  addDifferentVehicle() {
    this.initData();
    this.differentVehicle = true;
    this.selectedIndex = 1;
  }

  validateAndSend() {
    // Validate
    if (this.damageCase.Damages.length === 0) {
      this.toast.fire(this.translation.YouMustSelectAtLeastOneDamage, '', 'error');
      return;
    }
    if (this.damageCase.CostEstimate !== null) {
      if (this.damageCase.DamageDocuments.length === 0) {
        this.toast.fire(this.translation.DamageCaseValidationMessageCostEstimateFile, '', 'error');
        return;
      }
    }
    if (this.damageCase.DamageDocuments.length > 0) {
      if (this.damageCase.CostEstimate === null) {
        this.toast.fire(this.translation.DamageCaseValidationMessageCostEstimateAmount, '', 'error');
        return;
      }
    }
    if (this.differentVehicle) {
      if (this.damageCase.OriginalSender === '') {
        this.toast.fire(this.translation.SenderMustBeFilled, '', 'error');
        return;
      }
      if (this.damageCase.OriginalRecipient === '') {
        this.toast.fire(this.translation.RecipientMustBeFilled, '', 'error');
        return;
      }
      if (this.damageCase.Identification === '') {
        this.toast.fire(this.translation.IdentificationMustBeFilled, '', 'error');
        return;
      }
      if (this.damageCase.OriginalModel === '') {
        this.toast.fire(this.translation.VehcileMustBeFilled, '', 'error');
        return;
      }
      if (this.damageCase.ChassisNo === '') {
        this.toast.fire(this.translation.ChassisNoMustBeFilled, '', 'error');
        return;
      }
      if (this.damageCase.ChassisNo.length != 17) {
        this.toast.fire(this.translation.ChassisNumber + ' ' + this.translation.MustBeSeventeenDigits, '', 'error');
        return;
      }
      if (this.damageCase.License === '') {
        this.toast.fire(this.translation.LicensePlateMustBeFilled, '', 'error');
        return;
      }
    }
    this.prepareSend();
  }

  prepareSend() {
    Swal.fire({
      title: this.translation.AreYouSure + '...?',
      text: '...' + this.translation.AreYouSurePart2,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#CC0000',
      cancelButtonColor: '#CC0000',
      confirmButtonText: this.translation.Yes,
      cancelButtonText: this.translation.No,
    }).then((result) => {
      if (result.isConfirmed) {
        this.send();
      } else {
        Swal.fire({
          title: this.translation.Information,
          text: this.translation.NoIamNot,
          icon: 'info',
          confirmButtonColor: '#CC0000',
          confirmButtonText: 'OK',
        });
      }
    });
  }
  
  async send() {
    // Transform DamageDate
    this.damageCase.DamageDate = this.datepipe.transform(this.tempDate, 'dd.MM.yyyy');

    // Sleep Timer. All "uploaded" files need time to fill its content.
    await new Promise(f => setTimeout(f, 1000));

    // Call Backend
    this.damageAdministrationService.insertDamageCase(this.damageCase).subscribe(response => {
      if (response.Ok) {
        if (this.damageCase.CostEstimate === 0 || this.damageCase.CostEstimate === null) {
          Swal.fire({
            title: this.translation.Success,
            text: this.translation.DamageReportSuccessWithInfoMessage,
            confirmButtonColor: '#CC0000',
            icon: 'info'}
          );
        } else {
          this.toast.fire(this.translation.Success, this.translation.DamageCaseSuccessMessage, 'success');
        }
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      this.loadDataForGrid();
      this.initData();
      this.goBack();
    }), error => {
      this.toast.fire(this.translation.InternalServerError, '', 'error');
      this.loadDataForGrid();
      this.initData();
      this.goBack();
    };
  }
  
  onCostEstimateFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    
    const file = Array.from(input.files)[0];
    this.removeCostEstimateFile();

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const damageDocument = new DamageDocument();
      damageDocument.Id = 0;
      damageDocument.DocumentType = '0';
      damageDocument.FileName = file.name;
      damageDocument.CaseId = this.damageCase.Id;
      damageDocument.Base64 = reader.result as string;
      this.damageCase.DamageDocuments.push(damageDocument);
    };
  }
  
  removeCostEstimateFile() {
    this.damageCase.DamageDocuments = this.damageCase.DamageDocuments.filter(o => o.DocumentType !== '0');
  }
  
  onDamageFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    if (input.files.length > 0 && input.files.length <= 4) {
      const files = Array.from(input.files);
      this.damage.Images = [];

      files.forEach(file => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          const damageImage = new DamageImage();
          damageImage.Base64 = reader.result as string;
          if (!this.IsImage(damageImage.Base64)) {
            this.toast.fire(this.translation.AddImageErrorMessage, '', 'error');
            return;
          }
          damageImage.FileName = file.name;
          this.damage.Images.push(damageImage);
        };
      });
    } else {
      this.toast.fire(this.translation.AddImageErrorMessageMaxFour, '', 'error');
      input.value = "";
    }
  }
  
  saveDamage() {
    if (!this.validateDamage()) return;
    this.damage.InEdit = false;
    this.damageCase.Damages.push(this.damage);
    this.damage = new Damage();
    this.damage.Images = [];
  }

  cancelDamage() {
    this.damage = new Damage();
    this.damage.InEdit = false;
    this.damage.Images = [];
  }
  
  validateDamage() {
    if (this.damage.AreaId == null) {
      this.toast.fire(this.translation.AddDamageErrorMessageNoArea, '', 'warning');
      return false;
    }
    if (this.damage.TypeId == null) {
      this.toast.fire(this.translation.AddDamageErrorMessageNoType, '', 'warning');
      return false;
    }
    if (this.damage.Images.length == 0) {
      this.toast.fire(this.translation.AddDamageErrorMessageNoImage, '', 'warning');
      return false;
    }
    return true;
  }
  
  removeDamage(damage: Damage) {
    this.damageCase.Damages = this.damageCase.Damages.filter(o => o != damage);
  }

  onPreviewClick(dataUrl: string) {
    const base64 = dataUrl.split(',')[1];
    const mimeType = dataUrl.match(/^data:(.*);base64,/)?.[1] || '';

    // Base64 to ArrayBuffer
    const byteString = atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uintArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uintArray[i] = byteString.charCodeAt(i);
    }

    // Create Blob (PNG)
    const blob = new Blob([uintArray], { type: mimeType });

    // Temporary URL
    const url = URL.createObjectURL(blob);

    // Open new tab
    window.open(url, '_blank');
  }

  IsImage(base64: string): boolean {
    return base64?.trim().startsWith('data:image');
  }

  toolbarClick(args: any): void {
    if (args.item.id === 'AddDifferentVehicle') {
      this.addDifferentVehicle();
    }
  }
}
